<template>
  <div style="padding: 30px">
    <div v-if="is_loading" class="text-center" style="padding: 80px 0px">
      <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
    </div>

    <div v-else>
      <v-container>
        <v-row>
          <v-col cols="6" sm="4">
            <v-checkbox
              class="mt-0"
              v-model="configurations.enable_etsy_order_rename"
              label="Set Shopify order ID to Etsy order ID"
              color="primary"
              hide-details
              readonly
            ></v-checkbox>
          </v-col>

          <v-col cols="6" sm="4">
            <v-checkbox
              class="mt-0"
              v-model="configurations.enable_receipt_id_in_order_note"
              label="Show Etsy order ID on Shopify order note"
              color="primary"
              hide-details
              readonly
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4">
            <h4># Prefix for the Shopify order ID:</h4>
            <p>--> {{ configurations.shopify_order_rename_prefix }}</p>
          </v-col>
          <v-col cols="12" sm="4">
            <h4># Prefix for the Etsy order id in Shopify order note</h4>
            <p>--> {{ configurations.shopify_order_note_prefix }}</p>
          </v-col>
        </v-row>

        <v-divider class="mb-3"></v-divider>
        <v-row>
          <v-col cols="12">
            <h3>Etsy Tag Configuration</h3>
            <v-checkbox
              class="mt-2"
              v-model="configurations.enable_receipt_id_in_order_note"
              label="Enable Etsy tags in Shopify orders"
              color="primary"
              hide-details
              readonly
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-divider class="mb-3 mt-3"></v-divider>
        <h3>Sync Tax/VAT from Etsy Order to Shopify</h3>
        <v-row>
          <v-col cols="12">
            <h4 class="mt-3">Etsy Tax & VAT Synchronization</h4>
            <v-checkbox
              class="mt-2"
              v-model="configurations.sync_tax_on_etsy_orders"
              label="Sync TAX from Etsy order"
              color="primary"
              hide-details
              readonly
            ></v-checkbox>
            <v-checkbox
              class="mt-2"
              v-model="configurations.sync_vat_on_etsy_orders"
              label="Sync VAT from Etsy order"
              color="primary"
              hide-details
              readonly
            ></v-checkbox>
            <v-checkbox
              class="mt-2"
              v-model="configurations.price_inclusive_of_vat"
              label="Is your Etsy product's price inclusive of VAT?"
              color="primary"
              hide-details
              readonly
            ></v-checkbox>
            <v-checkbox
              class="mt-2"
              v-model="shop.tax_shipping"
              label="Is your Etsy order's shipping price inclusive of VAT?"
              color="primary"
              hide-details
              readonly
            ></v-checkbox>
          </v-col>

          <v-col cols="12">
            <h4>VAT sync setting</h4>

            <v-radio-group v-model="syncVatAsString" row>
              <v-radio readonly label="Sync VAT with inclusive in price" value="1"></v-radio>
              <v-radio readonly label="Sync VAT with exclusive in price" value="0"></v-radio>
            </v-radio-group>

            <h4># VAT % on Etsy Product</h4>
            <p>--> {{ configurations.etsy_vat_percent }}%</p>

            <div v-if="configurations.country_vat_mappings && configurations.country_vat_mappings.length > 0">
              <h4 class="mt-4 mb-2">
                Country VAT Mappings
              </h4>

              <v-data-table
                :headers="headers"
                :items="configurations.country_vat_mappings"
                :items-per-page="10"
                class="elevation-1 mt-5"
              >
                <template v-slot:top>
                  <v-row style="padding: 10px">
                    <v-col
                      md="2"
                      cols="6"
                    >
                      <strong>Total: </strong> {{ configurations.country_vat_mappings.length }}
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:body="{ items }">
                  <tbody v-if="!is_loading">
                    <tr v-for="(item, index) in items" :key="index">
                      <td>{{ item.country }}</td>
                      <td>{{ item.vat_percent }}%</td>
                    </tr>
                  </tbody>

                  <tbody v-else>
                    <tr>
                      <td
                        colspan="6"
                        class="text-center"
                        style="padding: 80px 0px"
                      >
                        <img
                          :src="require('@/assets/images/misc/loading.gif')"
                          alt=""
                          width="100px"
                        />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </div>

            <h4 class="mt-6"># VAT % on Etsy Shipping</h4>
            <p>--> {{ configurations.etsy_shipping_percent }}%</p>
          </v-col>
        </v-row>
        <v-divider class="mb-3 mt-3"></v-divider>
        <v-row>
          <v-col cols="12">
            <h3>Etsy Order Fulfillment Configuration</h3>
            <v-checkbox
              class="mt-2"
              v-model="configurations.fulfill_with_tracking_number"
              label="Only sync order fulfillments to Etsy with tracking numbers"
              color="primary"
              hide-details
              readonly
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import store from '@/store'
export default {
  data() {
    return {
      shop: null,
      is_loading: false,
      configurations: {},
      headers: [
        { text: 'Country', value: 'country' },
        { text: 'VAT', value: 'vat_percent' },
      ],
    }
  },
  computed: {
    syncVatAsString: {
      get() {
        return String(this.configurations.sync_vat_inclusive_in_price)
      },
    },
  },
  mounted() {
    this.shop = store.getters.loggedInShop
    this.fetchConfigurations()
  },
  methods: {
    async fetchConfigurations() {
      try {
        this.is_loading = true
        let response = await axios.get(`admin/shops/${this.shop.id}/get-configurations`)
        if (response.data.success) {
          this.configurations = response.data.configurations
        }
      } catch (e) {
      } finally {
        this.is_loading = false
      }
    },
  },
}
</script>
